export default {
    errors: null,
    successMessage: null,
    loading: false,
    ticketStatus: [],
    ticketEscalated: false,
    accessToken: null,
    user: {},
    auth: {
        permissions: [],
        roles: [],
    },
    images:{},
    apps: [],
    notifications: [],
    topics:[],
    isReferrerRegistered: false,
    appSelected:null,
    guideTopicId: null,
    guideTestResultId: null,
    guide_application_id:null
}